export const BENEFIT_ICON_KEYS = [
  "mailbox",
  "house-dollar",
  "megaphone",
  "person",
  "book",
  "chart",
  "shield",
  "users",
];

const ICON_ORDER = BENEFIT_ICON_KEYS;

export function pickBenefitIcon(icon, index) {
  return icon || ICON_ORDER[index % ICON_ORDER.length];
}

export function BenefitIcon({ icon, className }) {
  const props = {
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
  };

  switch (icon) {
    case "mailbox":
      return (
        <svg {...props}>
          <path d="M3 10a5 5 0 0 1 5-5h7v10H8a5 5 0 0 1-5-5Z" />
          <path d="M15 5v10" />
          <circle cx="6" cy="10" r="1.4" fill="currentColor" stroke="none" />
          <path d="M15 8h5v2h-2" />
          <path d="M3 15v2M9 17h4" />
        </svg>
      );
    case "house-dollar":
      return (
        <svg {...props}>
          <path d="M4 11.5 12 4l8 7.5" />
          <path d="M6 10v9h12v-9" />
          <path d="M12 10.5v8" />
          <path d="M10.3 16.2c0 .8.8 1.3 1.7 1.3s1.7-.5 1.7-1.2c0-.9-.8-1.2-1.7-1.4-.9-.2-1.7-.5-1.7-1.4 0-.7.8-1.2 1.7-1.2s1.7.5 1.7 1.3" />
        </svg>
      );
    case "megaphone":
      return (
        <svg {...props}>
          <path d="M3 11v2a2 2 0 0 0 2 2h1l9 4V5L6 9H5a2 2 0 0 0-2 2Z" />
          <path d="M15 8.5a4 4 0 0 1 0 7" />
          <path d="M6 15v4a1.5 1.5 0 0 0 3 0v-3" />
        </svg>
      );
    case "person":
      return (
        <svg {...props}>
          <circle cx="12" cy="7" r="3.2" />
          <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
          <path d="M12 13.5v3M10.3 15h3.4" />
        </svg>
      );
    case "book":
      return (
        <svg {...props}>
          <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H12v18H6.5A2.5 2.5 0 0 1 4 18.5v-13Z" />
          <path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H12v18h5.5a2.5 2.5 0 0 0 2.5-2.5v-13Z" />
        </svg>
      );
    case "chart":
      return (
        <svg {...props}>
          <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
          <path d="M13 8l3-3 3 3" />
        </svg>
      );
    case "shield":
      return (
        <svg {...props}>
          <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case "users":
      return (
        <svg {...props}>
          <circle cx="9" cy="8" r="3" />
          <path d="M3 20c0-3 2.7-5.5 6-5.5s6 2.5 6 5.5" />
          <circle cx="17" cy="8.5" r="2.3" />
          <path d="M16 14.8c2.4.4 4 2.4 4 5.2" />
        </svg>
      );
    default:
      return null;
  }
}
